import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { api } from 'apis/axiosInstance'
import { Toastr } from 'components/global/Toastr'
import { HTTPValidationError } from 'types/httpTypes'
import { API_VERSION_TWO } from 'utils/apiUtils'
import { ApiResponse, SurveyFillBody } from './types'

type Response = ApiResponse<{ message: string }>

const updateSurveys = (data: SurveyFillBody): Promise<Response> => {
  return api({
    url: `/${API_VERSION_TWO}/common/survey_answers`,
    method: 'POST',
    data: {
      survey_answer: data,
    },
  })
}

export const useFillSurveyForm = <TError extends HTTPValidationError>(opts?: {
  mutation?: UseMutationOptions<Response, TError, { data: SurveyFillBody }>
}) => {
  return useMutation({
    ...(opts?.mutation || {}),
    mutationFn: (payload) => updateSurveys(payload.data),
    onSuccess: (res) => {
      Toastr.success(res?.data?.message)
    },
    onError: (error, variables, context) => {
      if (error.response?.data.error) Toastr.error(error.response?.data.error)
      opts?.mutation?.onError?.(error, variables, context)
    },
  })
}
